import React, { useState } from 'react';

import { postPreSignup as postPreSignupApi } from '@/apis/Marketing/preSignupApi';
import { PreSignupViewer } from './preSignupViewer';

const initialFormValues = {
  full_name: '',
  work_email: '',
  company_name: '',
  team_size: '',
  ai_interest: '',
};

export function PreSignupController() {
  const [formValues, setFormValues] = useState(initialFormValues);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    setFormValues((currentValues) => ({
      ...currentValues,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitError('');
    setIsSubmitting(true);

    try {
      await postPreSignupApi(formValues);
      setIsSubmitted(true);
      setFormValues(initialFormValues);
    } catch (error) {
      setSubmitError(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PreSignupViewer
      formValues={formValues}
      onFieldChange={handleFieldChange}
      onSubmit={handleSubmit}
      isSubmitted={isSubmitted}
      isSubmitting={isSubmitting}
      submitError={submitError}
    />
  );
}
